 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_Cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDAD1 from '@/components/Backed/ad1'
 import LOVE_2 from '@/components/love_2'
 import A2_TP from '@/components/02_tp'
 import A4_TOC from '@/components/04_toc'
 import A5_DED from '@/components/05_ded'
 import A7_POEM from '@/components/07_poem'
 import A8_FM from '@/components/08_fm'
 import A9_PRF1 from '@/components/09_prf1'
 import A0_PRF2 from '@/components/10_prf2'
 import A1_FORE from '@/components/11_fore'
 import A2_CH01 from '@/components/12_ch01'
 import A3_CH02 from '@/components/13_ch02'
 import A4_CH03 from '@/components/14_ch03'
 import A5_CH04 from '@/components/15_ch04'
 import A6_CH05 from '@/components/16_ch05'
 import A7_CH06 from '@/components/17_ch06'
 import A8_CH07 from '@/components/18_ch07'
 import A9_CH08 from '@/components/19_ch08'
 import A0_CH09 from '@/components/20_ch09'
 import A1_CH10 from '@/components/21_ch10'
 import A1_CH11 from '@/components/21_ch11'
 import LOVE_1 from '@/components/love_1'
 import A2_EPI from '@/components/22_epi'
 import A3_LATER from '@/components/23_later'
 import A4_APPA from '@/components/24_appA'
 import A5_APPB from '@/components/25_appB'
 import A6_APPC from '@/components/26_appC'
 import A7_APPD from '@/components/27_appD'
 import A8_APPE from '@/components/28_appE'
 import A9_NOTES from '@/components/29_notes'
 import A0_REF from '@/components/30_ref'
 import A6_ACK from '@/components/06_ack'
 import A3_COPY from '@/components/03_copy'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import CASEMATE from '@/components/casemate'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/00_Cover",
 			"name" : "00_Cover",
 			"component" : A0_COVER
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/ad1",
 			"name" : "Backed/ad1",
 			"component" : BACKEDAD1
 		},
 		{
 			"path" : "/love_2",
 			"name" : "love_2",
 			"component" : LOVE_2
 		},
 		{
 			"path" : "/02_tp",
 			"name" : "02_tp",
 			"component" : A2_TP
 		},
 		{
 			"path" : "/04_toc",
 			"name" : "04_toc",
 			"component" : A4_TOC
 		},
 		{
 			"path" : "/05_ded",
 			"name" : "05_ded",
 			"component" : A5_DED
 		},
 		{
 			"path" : "/07_poem",
 			"name" : "07_poem",
 			"component" : A7_POEM
 		},
 		{
 			"path" : "/08_fm",
 			"name" : "08_fm",
 			"component" : A8_FM
 		},
 		{
 			"path" : "/09_prf1",
 			"name" : "09_prf1",
 			"component" : A9_PRF1
 		},
 		{
 			"path" : "/10_prf2",
 			"name" : "10_prf2",
 			"component" : A0_PRF2
 		},
 		{
 			"path" : "/11_fore",
 			"name" : "11_fore",
 			"component" : A1_FORE
 		},
 		{
 			"path" : "/12_ch01",
 			"name" : "12_ch01",
 			"component" : A2_CH01
 		},
 		{
 			"path" : "/13_ch02",
 			"name" : "13_ch02",
 			"component" : A3_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js